export default __webpack_public_path__ + "static/media/Contract.eccc8de9.png";